import { pcbWebSocketEndpoints } from '../pcb/pcbWebSocketEndpoints';

type InnerPcbWebSocketEndpoint = typeof pcbWebSocketEndpoints;

interface IWebSocketEndpointRegistry extends InnerPcbWebSocketEndpoint {}

export const webSocketEndpointRegistry: IWebSocketEndpointRegistry = {
    ...pcbWebSocketEndpoints,
};
